import { render, staticRenderFns } from "./checkbox-field.vue?vue&type=template&id=f257d55e&scoped=true&"
import script from "./checkbox-field.vue?vue&type=script&lang=js&"
export * from "./checkbox-field.vue?vue&type=script&lang=js&"
import style0 from "./checkbox-field.vue?vue&type=style&index=0&id=f257d55e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f257d55e",
  null
  
)

export default component.exports